import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client, { imgUrl, shuffled } from "@/lib/glossyApi";
import MiniAd from "@/components/MiniAd";
import MagazineLayout from "@/components/MagazineLayout";
import { Reveal } from "@/components/Reveal";

export default function CoverMembers() {
  const [members, setMembers] = useState([]);
  useEffect(() => {
    document.title = "Cover Members — S/ME";
    client.get("/members").then((r) => setMembers(shuffled(r.data))).catch(() => {});
  }, []);

  return (
    <MagazineLayout>
      <div className="pt-[68px] bg-cream min-h-screen" data-testid="cover-members-page">
        <header className="px-5 sm:px-8 pt-16 sm:pt-24 pb-10 max-w-[1600px] mx-auto">
          <p className="overline text-gloss-gold mb-4">The Stars</p>
          <h1 className="font-serif text-5xl sm:text-7xl lg:text-8xl tracking-tight leading-none">Cover Members</h1>
          <p className="font-sans text-lg text-ink/70 mt-5 max-w-xl">The UK's independents, shot like the icons they are. Every S/ME member, on the cover.</p>
        </header>
        <div className="px-5 sm:px-8 max-w-[1600px] mx-auto mb-10"><MiniAd variant="banner" space="covermembers_banner" /></div>
        <section className="px-5 sm:px-8 pb-28 max-w-[1600px] mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 sm:gap-8">
            {members.filter((m) => m.directory_image).map((m, i) => (
              <Reveal key={m.id} delay={(i % 4) * 0.06}>
                <Link to={`/member/${m.id}`} className="group block" data-testid="cover-member-card">
                  <div className="relative overflow-hidden aspect-[2/3] bg-ink ed-frame">
                    <img src={imgUrl({ cover_image: m.directory_image, fallback_image: m.fallback_image })} alt={m.owner_name} className="w-full h-full object-cover object-top ed-grade transition-transform duration-700 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/85" />
                    {!m.directory_image && (
                      <div className="absolute top-0 left-0 right-0 z-10 flex items-start justify-between px-3 pt-3 gap-2">
                        <span className="font-serif text-cream text-2xl sm:text-3xl leading-none tracking-tight">S/ME</span>
                        <span className="font-mono text-[8px] uppercase tracking-widest text-cream/70 shrink-0">{m.business_category || m.category}</span>
                      </div>
                    )}
                    <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-4 z-10">
                      <p className="font-mono text-[9px] sm:text-[10px] uppercase tracking-widest text-gloss-gold">{m.borough}</p>
                      <p className="font-serif text-base sm:text-xl leading-tight mt-1 text-cream">{m.owner_name}</p>
                      <p className="font-sans text-[11px] sm:text-xs text-cream/70">{m.business_name}</p>
                    </div>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
          {members.length === 0 && <p className="font-sans text-ink/50 py-20 text-center border-t border-ink/20">The first cover members are being shot now.</p>}
        </section>
      </div>
    </MagazineLayout>
  );
}
